//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex';

export default {
    name: "AppFilterList",
	computed: {
        ...mapGetters(['getQueryFilters'])
    },
    methods: {
        ...mapActions(['toggleFilter', 'showFilters'])
    }
};
